import {
  $serializer_getInstance2m8ynx42p4oox as $serializer_getInstance,
  $serializer_getInstance2jfn7wtddihen as $serializer_getInstance_0,
  Companion_getInstance1wc081wkfo40w as Companion_getInstance,
  Companion_getInstance2kycdbli06tg as Companion_getInstance_0,
  IDqqik72jjbpsn as ID,
  ID1lyj7m2ox8cp5 as ID_0,
  Employer27b20p5x27kte as Employer,
  ID__toString_impl_y5caka2oopvpysxo85x as ID__toString_impl_y5caka,
  get_entries3tl980hg1b2bm as get_entries,
  get_entries2mjjs5oycal4x as get_entries_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  QuestionResponse2c5i2ax2qx74j as QuestionResponse,
  SurveyProgress2a3z8tdqg3ffh as SurveyProgress,
  ID3b6wrkk3fpdmq as ID_1,
  ID2laazuggebybv as ID_2,
  FreeNumber2skpobtqdwens as FreeNumber,
  FreeText_getInstance23qqf2uelwn34 as FreeText_getInstance,
  Scale39z6qxcb8qv as Scale,
  MultipleChoice1goezt0bzeu0r as MultipleChoice,
  SingleChoice36vk2iz8s7aee as SingleChoice,
  Survey1bcnex3xrekf as Survey,
  ID__toString_impl_y5caka2oex5pjttokev as ID__toString_impl_y5caka_0,
  Audience_Families_getInstance8s10akugcgmf as Audience_Families_getInstance,
  Audience_AnonymousEmployee_getInstance2bv7u5yl59uph as Audience_AnonymousEmployee_getInstance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  get_notNull2od35hy6ssmdh as get_notNull,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_demographicmlqzvs0t1ul4 as get_demographic,
  get_supportingEmployers2109hzg0jtzbr as get_supportingEmployers,
  get_takerEmployer1i90yvm39mbzg as get_takerEmployer,
  get_supportingGrants35nmqgmty3bao as get_supportingGrants,
  get_income7rv80eiwnca0 as get_income,
  get_leadershipLevel3vlrbz5tqiro3 as get_leadershipLevel,
  get_city2k035u7pra9ih as get_city,
  get_survey39c7m1qh20u4e as get_survey,
  get_completedAt2o81s1ul0ktr1 as get_completedAt,
  get_name3gijmx3xstqlj as get_name,
  get_survey1jt3rdrcg0rh4 as get_survey_0,
  get_question2rd5ppp1vbac2 as get_question,
  get_familySizeg8giw0lzo5tk as get_familySize,
  get_takerIteration1i7xba92wxwha as get_takerIteration,
  get_answerScale2z0xdsq82vzwn as get_answerScale,
  get_answerMultipleChoice1d0eh30iadr4j as get_answerMultipleChoice,
  get_answerSingleChoice1bo4u7v2iayry as get_answerSingleChoice,
  get_answerFreeNumber3m8fwci6bexgk as get_answerFreeNumber,
  get_at32g2hzsls3ow0 as get_at,
  get_available29p7gsw45t1wj as get_available,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet,
  eq353yrgcpovoi1 as eq,
  neqpgb3jcwulnab as neq,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  SetAnyElements2se8zlywewplk as SetAnyElements,
  or1uh2qn0k1rz6c as or,
  And1a3dbpwh0hxmu as And,
  and3dbt2f202um49 as and,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf,
  listOfNotNull1v4ggfackvuny as listOfNotNull_0,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  copyToArray2j022khrow2yi as copyToArray,
  mapOf2zpbbmyqk8xpf as mapOf,
  listOfvhqybd2zx248 as listOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { coroutineScope2qhrb6lhutwsn as coroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import {
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
} from '../components/view-utilities.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_1,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  h2ld0l0a2c9zpb as h2,
  text189ciz0cnr32o as text,
  subtext2yjmf1ok7kb40 as subtext,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  setClipboardTextsmriix4g698x as setClipboardText,
  download3e9i5zj8k9dp8 as download,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import {
  first58ocm7j58k3q as first,
  plus310ted5e4i90h as plus,
  joinToString1cxrrlmo0chqs as joinToString,
  asSequence2phdjljfh9jhx as asSequence,
  sorted354mfsiv4s7x5 as sorted,
  sortedWith2csnbbb21k0lg as sortedWith,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { AnonymousSurveyPage31h992m9jks1x as AnonymousSurveyPage } from './AnonymousSurveyPage.mjs';
import { webOrigin32whb6fx4rie as webOrigin } from '../../actuals/WebOrigin.js.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { sequenceOfdrc6uefhtiet as sequenceOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { plus2l6bq32n2wlna as plus_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { appendCsvRows26y51byhnrjfx as appendCsvRows } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvConfig.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import {
  SurveyNewPage2cofqn1wxyvtq as SurveyNewPage,
  Companion_instance2m38mzj1la79m as Companion_instance_0,
  get_displayNamexov4bi48nyz9 as get_displayName,
} from './SurveyNewPage.mjs';
import {
  GroupCountQueryynttufojs10g as GroupCountQuery,
  GroupAggregateQuery38kwelc2aunpz as GroupAggregateQuery,
  AggregateQueryy3011hqgitfl as AggregateQuery,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/GroupCountQuery.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_1,
  tablezpetcq9vbay1 as table,
} from '../components/table.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_2,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { toIntOrNull3w2d066r9pvwm as toIntOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { Aggregate_Average_getInstance1jkg6g5zxf9jw as Aggregate_Average_getInstance } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Aggregate.mjs';
import { toInt2q8uldh7sc951 as toInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  emptyMapr06gerzljqtm as emptyMap,
  getValue48kllevslyh6 as getValue,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAllfig2t8ybkmg8 as awaitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { LocalDateRangefowoyqa24icz as LocalDateRange } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_availabilityText38mli3yvvkbrx as get_availabilityText } from './surveyComponents.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  chipMultiselect24u6i0cuozpmn as chipMultiselect,
  chipMultiselectToggleWithId487as59uzyv9 as chipMultiselectToggleWithId,
} from '../components/multiselect.mjs';
import { filterMenu2fz1h01y9a2vu as filterMenu } from '../components/filters.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_3 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { colOf78ko504rukk8 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function SurveyFilters$Companion$$childSerializers$_anonymous__nhofft() {
  return new (LinkedHashSetSerializer())($serializer_getInstance());
}
function SurveyFilters$Companion$$childSerializers$_anonymous__nhofft_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_0());
}
function SurveyFilters$Companion$$childSerializers$_anonymous__nhofft_1() {
  return new (LinkedHashSetSerializer())(Companion_getInstance().serializer_9w0wvi_k$());
}
function SurveyFilters$Companion$$childSerializers$_anonymous__nhofft_2() {
  return new (LinkedHashSetSerializer())(Companion_getInstance_0().serializer_9w0wvi_k$());
}
function SurveyFilters$Companion$$childSerializers$_anonymous__nhofft_3() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, SurveyFilters$Companion$$childSerializers$_anonymous__nhofft);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, SurveyFilters$Companion$$childSerializers$_anonymous__nhofft_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, SurveyFilters$Companion$$childSerializers$_anonymous__nhofft_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, SurveyFilters$Companion$$childSerializers$_anonymous__nhofft_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [tmp_1, tmp_3, tmp_5, tmp_7, lazy(tmp_8, SurveyFilters$Companion$$childSerializers$_anonymous__nhofft_3)];
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  if (Companion_instance_3 === VOID)
    new (Companion())();
  return Companion_instance_3;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.surveys.SurveyFilters', this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('employers', true);
        tmp0_serialDesc.addElement_5pzumi_k$('grants', true);
        tmp0_serialDesc.addElement_5pzumi_k$('incomes', true);
        tmp0_serialDesc.addElement_5pzumi_k$('leadershipLevels', true);
        tmp0_serialDesc.addElement_5pzumi_k$('cities', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_qpktla_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_4().$childSerializers_1;
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.employers_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.employers_1);
        }
        var tmp_0;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_0 = !equals(value.grants_1, tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.grants_1);
        }
        var tmp_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2)) {
          tmp_1 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$2 = emptySet();
          tmp_1 = !equals(value.incomes_1, tmp$ret$2);
        }
        if (tmp_1) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.incomes_1);
        }
        var tmp_2;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3)) {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$3 = emptySet();
          tmp_2 = !equals(value.leadershipLevels_1, tmp$ret$3);
        }
        if (tmp_2) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.leadershipLevels_1);
        }
        var tmp_3;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp_3 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$4 = emptySet();
          tmp_3 = !equals(value.cities_1, tmp$ret$4);
        }
        if (tmp_3) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.cities_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_qpktla_k$(encoder, value instanceof SurveyFilters() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance_4().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp10_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp10_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp10_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp10_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp10_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp10_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SurveyFilters().new_org_thecommunitygroupinc_cares_views_surveys_SurveyFilters_c32dfp_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_4().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].get_value_j01efc_k$(), tmp0_cached[1].get_value_j01efc_k$(), tmp0_cached[2].get_value_j01efc_k$(), tmp0_cached[3].get_value_j01efc_k$(), tmp0_cached[4].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_1() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var SurveyFiltersClass;
function SurveyFilters() {
  if (SurveyFiltersClass === VOID) {
    class $ {
      constructor(employers, grants, incomes, leadershipLevels, cities) {
        Companion_getInstance_4();
        var tmp;
        if (employers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = employers;
        }
        employers = tmp;
        var tmp_0;
        if (grants === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = grants;
        }
        grants = tmp_0;
        var tmp_1;
        if (incomes === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = incomes;
        }
        incomes = tmp_1;
        var tmp_2;
        if (leadershipLevels === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_2 = emptySet();
        } else {
          tmp_2 = leadershipLevels;
        }
        leadershipLevels = tmp_2;
        var tmp_3;
        if (cities === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_3 = emptySet();
        } else {
          tmp_3 = cities;
        }
        cities = tmp_3;
        this.employers_1 = employers;
        this.grants_1 = grants;
        this.incomes_1 = incomes;
        this.leadershipLevels_1 = leadershipLevels;
        this.cities_1 = cities;
      }
      toCondition_oj74tc_k$() {
        // Inline function 'kotlin.takeIf' call
        var this_0 = this.employers_1;
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_0.isEmpty_y1axqb_k$()) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
          var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$7);
          // Inline function 'com.lightningkite.services.database.any' call
          var this_1 = get_supportingEmployers(get_demographic(it));
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(ID()), arrayOf([]), false));
          var tmp$ret$12 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$12);
          var tmp$ret$13 = xDataClassPathInsideSet(it_0, tmp0_safe_receiver);
          var tmp$ret$10 = this_1.mapCondition_3hl8s3_k$(SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(tmp$ret$13));
          tmp_0 = or(tmp$ret$10, xDataClassPathInsideSet(get_notNull(get_takerEmployer(get_demographic(it))), tmp0_safe_receiver));
        }
        var tmp_3 = tmp_0;
        // Inline function 'kotlin.takeIf' call
        var this_2 = this.grants_1;
        var tmp_4;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_2.isEmpty_y1axqb_k$()) {
          tmp_4 = this_2;
        } else {
          tmp_4 = null;
        }
        var tmp1_safe_receiver = tmp_4;
        var tmp_5;
        if (tmp1_safe_receiver == null) {
          tmp_5 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_6 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
          var tmp$ret$22 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_1 = new (DataClassPathSelf())(tmp$ret$22);
          // Inline function 'com.lightningkite.services.database.any' call
          var this_3 = get_supportingGrants(get_demographic(it_1));
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_7 = serializerOrContextual(createKType(getKClass(ID_0()), arrayOf([]), false));
          var tmp$ret$27 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_2 = new (DataClassPathSelf())(tmp$ret$27);
          var tmp$ret$28 = xDataClassPathInsideSet(it_2, tmp1_safe_receiver);
          tmp_5 = this_3.mapCondition_3hl8s3_k$(SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(tmp$ret$28));
        }
        var tmp_8 = tmp_5;
        // Inline function 'kotlin.takeIf' call
        var this_4 = this.incomes_1;
        var tmp_9;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_4.isEmpty_y1axqb_k$()) {
          tmp_9 = this_4;
        } else {
          tmp_9 = null;
        }
        var tmp2_safe_receiver = tmp_9;
        var tmp_10;
        if (tmp2_safe_receiver == null) {
          tmp_10 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_11 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
          var tmp$ret$37 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_3 = new (DataClassPathSelf())(tmp$ret$37);
          tmp_10 = xDataClassPathInsideSet(get_notNull(get_income(get_demographic(it_3))), tmp2_safe_receiver);
        }
        var tmp_12 = tmp_10;
        // Inline function 'kotlin.takeIf' call
        var this_5 = this.leadershipLevels_1;
        var tmp_13;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_5.isEmpty_y1axqb_k$()) {
          tmp_13 = this_5;
        } else {
          tmp_13 = null;
        }
        var tmp3_safe_receiver = tmp_13;
        var tmp_14;
        if (tmp3_safe_receiver == null) {
          tmp_14 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_15 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
          var tmp$ret$47 = isInterface(tmp_15, KSerializer()) ? tmp_15 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_4 = new (DataClassPathSelf())(tmp$ret$47);
          tmp_14 = xDataClassPathInsideSet(get_notNull(get_leadershipLevel(get_demographic(it_4))), tmp3_safe_receiver);
        }
        var tmp_16 = tmp_14;
        // Inline function 'kotlin.takeIf' call
        var this_6 = this.cities_1;
        var tmp_17;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_6.isEmpty_y1axqb_k$()) {
          tmp_17 = this_6;
        } else {
          tmp_17 = null;
        }
        var tmp4_safe_receiver = tmp_17;
        var tmp_18;
        if (tmp4_safe_receiver == null) {
          tmp_18 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_19 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
          var tmp$ret$57 = isInterface(tmp_19, KSerializer()) ? tmp_19 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_5 = new (DataClassPathSelf())(tmp$ret$57);
          tmp_18 = xDataClassPathInsideSet(get_city(get_demographic(it_5)), tmp4_safe_receiver);
        }
        return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp_3, tmp_8, tmp_12, tmp_16, tmp_18]));
      }
      activeCount_htest3_k$() {
        var tmp0 = listOf([this.employers_1, this.grants_1, this.incomes_1, this.leadershipLevels_1, this.cities_1]);
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.count' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = 0;
            break $l$block;
          }
          var count = 0;
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!element.isEmpty_y1axqb_k$()) {
              count = count + 1 | 0;
              checkCountOverflow(count);
            }
          }
          tmp$ret$0 = count;
        }
        return tmp$ret$0;
      }
      copy_q795wo_k$(employers, grants, incomes, leadershipLevels, cities) {
        return new (SurveyFilters())(employers, grants, incomes, leadershipLevels, cities);
      }
      copy$default_f6m8xw_k$(employers, grants, incomes, leadershipLevels, cities, $super) {
        employers = employers === VOID ? this.employers_1 : employers;
        grants = grants === VOID ? this.grants_1 : grants;
        incomes = incomes === VOID ? this.incomes_1 : incomes;
        leadershipLevels = leadershipLevels === VOID ? this.leadershipLevels_1 : leadershipLevels;
        cities = cities === VOID ? this.cities_1 : cities;
        return $super === VOID ? this.copy_q795wo_k$(employers, grants, incomes, leadershipLevels, cities) : $super.copy_q795wo_k$.call(this, employers, grants, incomes, leadershipLevels, cities);
      }
      toString() {
        return 'SurveyFilters(employers=' + toString(this.employers_1) + ', grants=' + toString(this.grants_1) + ', incomes=' + toString(this.incomes_1) + ', leadershipLevels=' + toString(this.leadershipLevels_1) + ', cities=' + toString(this.cities_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.employers_1);
        result = imul(result, 31) + hashCode(this.grants_1) | 0;
        result = imul(result, 31) + hashCode(this.incomes_1) | 0;
        result = imul(result, 31) + hashCode(this.leadershipLevels_1) | 0;
        result = imul(result, 31) + hashCode(this.cities_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SurveyFilters()))
          return false;
        if (!equals(this.employers_1, other.employers_1))
          return false;
        if (!equals(this.grants_1, other.grants_1))
          return false;
        if (!equals(this.incomes_1, other.incomes_1))
          return false;
        if (!equals(this.leadershipLevels_1, other.leadershipLevels_1))
          return false;
        if (!equals(this.cities_1, other.cities_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_surveys_SurveyFilters_c32dfp_k$(seen0, employers, grants, incomes, leadershipLevels, cities, serializationConstructorMarker) {
        Companion_getInstance_4();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.employers_1 = emptySet();
        } else
          $this.employers_1 = employers;
        if (0 === (seen0 & 2)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.grants_1 = emptySet();
        } else
          $this.grants_1 = grants;
        if (0 === (seen0 & 4)) {
          var tmp_1 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_1.incomes_1 = emptySet();
        } else
          $this.incomes_1 = incomes;
        if (0 === (seen0 & 8)) {
          var tmp_2 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_2.leadershipLevels_1 = emptySet();
        } else
          $this.leadershipLevels_1 = leadershipLevels;
        if (0 === (seen0 & 16)) {
          var tmp_3 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_3.cities_1 = emptySet();
        } else
          $this.cities_1 = cities;
        return $this;
      }
    }
    initMetadataForClass($, 'SurveyFilters', SurveyFilters, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    SurveyFiltersClass = $;
  }
  return SurveyFiltersClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function SurveyGrouping$Companion$_anonymous__jr3cnm() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.views.surveys.SurveyGrouping', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  SurveyGrouping_None_instance = new (SurveyGrouping())('None', 0, 'Nothing');
  SurveyGrouping_Income_instance = new (SurveyGrouping())('Income', 1, 'Income');
  SurveyGrouping_Leadership_instance = new (SurveyGrouping())('Leadership', 2, 'Leadership');
  SurveyGrouping_FamilySize_instance = new (SurveyGrouping())('FamilySize', 3, 'Family size');
  SurveyGrouping_City_instance = new (SurveyGrouping())('City', 4, 'City');
  SurveyGrouping_Employer_instance = new (SurveyGrouping())('Employer', 5, 'Employer');
  SurveyGrouping_Iteration_instance = new (SurveyGrouping())('Iteration', 6, 'Taking');
  if (Companion_instance_4 === VOID) {
    Companion_instance;
    new (Companion_0())();
  }
}
var SurveyGrouping_None_instance;
var SurveyGrouping_Income_instance;
var SurveyGrouping_Leadership_instance;
var SurveyGrouping_FamilySize_instance;
var SurveyGrouping_City_instance;
var SurveyGrouping_Employer_instance;
var SurveyGrouping_Iteration_instance;
function values() {
  static_init();
  return [SurveyGrouping_None_getInstance(), SurveyGrouping_Income_getInstance(), SurveyGrouping_Leadership_getInstance(), SurveyGrouping_FamilySize_getInstance(), SurveyGrouping_City_getInstance(), SurveyGrouping_Employer_getInstance(), SurveyGrouping_Iteration_getInstance()];
}
function get_entries_1() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, SurveyGrouping$Companion$_anonymous__jr3cnm);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_4;
function Companion_getInstance_5() {
  static_init();
  return Companion_instance_4;
}
var $ENTRIES;
var SurveyGroupingClass;
function SurveyGrouping() {
  if (SurveyGroupingClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'SurveyGrouping', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_5});
    SurveyGroupingClass = $;
  }
  return SurveyGroupingClass;
}
function get_displayName_0(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.ordinal_1) {
    case 0:
      tmp = 'Manages no one';
      break;
    case 1:
      tmp = 'Manages employees';
      break;
    case 2:
      tmp = 'Manages managers';
      break;
    case 3:
      tmp = 'Senior leader';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
var ResultsClass;
function Results() {
  if (ResultsClass === VOID) {
    class $ {
      constructor(columns, rows, texts) {
        this.columns_1 = columns;
        this.rows_1 = rows;
        this.texts_1 = texts;
      }
    }
    initMetadataForClass($, 'Results');
    ResultsClass = $;
  }
  return ResultsClass;
}
function *results($this, question, filter, grouping, $completion) {
  return yield* coroutineScope(SurveyDetailPage$results$slambda(filter, question, grouping), $completion);
}
function availabilityDialog($this, $receiver, survey) {
  return dialog($receiver, VOID, ($this$dialog, close) => {
    var tmp0_safe_receiver = survey.available_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.start_1;
    var start = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp1_elvis_lhs == null ? today() : tmp1_elvis_lhs);
    var tmp2_safe_receiver = survey.available_1;
    var endInclusive = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.endInclusive_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    h2(element, 'Availability');
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_content_lzqutq_k$('Opens');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_1 = themed(element_0, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (LocalDateField())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_1.willAddChild_hz2iwc_k$(element_1);
    element_1.bind_gesskf_k$(element_1.content_1, start);
    element_1.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_1);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label = 'Closes (optional)';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element.willAddChild_hz2iwc_k$(element_2);
    element_2.set_content_lzqutq_k$(label);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_2 = themed(element_2, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (LocalDateField())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_2.willAddChild_hz2iwc_k$(element_3);
    element_3.bind_gesskf_k$(element_3.content_1, endInclusive);
    element_3.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_3);
    element_2.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element.willAddChild_hz2iwc_k$(element_4);
    element_4.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_3 = themed(element_4, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (Button())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_3.willAddChild_hz2iwc_k$(element_5);
    text(element_5, 'Cancel');
    onClick(element_5, VOID, VOID, VOID, SurveyDetailPage$availabilityDialog$lambda$slambda(close));
    element_5.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_4 = weight(element_4, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Space())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_4.willAddChild_hz2iwc_k$(element_6);
    element_6.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_5 = themed(element_4, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_6 = themed(this_5, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (Button())(this_6.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    this_6.willAddChild_hz2iwc_k$(element_7);
    text(element_7, 'Save');
    element_7.set_action_2ds022_k$(Action('Save availability', VOID, VOID, VOID, VOID, VOID, SurveyDetailPage$availabilityDialog$lambda$slambda_0(start, $this, endInclusive, close)));
    element_7.onStartup_vrxh3i_k$();
    this_6.addChild_2qpft2_k$(element_7);
    element_4.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_4);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function SurveyDetailPage$render$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1.get_surveyProgress_gv29io_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(SurveyProgress()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp$ret$1 = and(eq(get_survey(it), new (ID_1())(this$0.id_1)), neq(get_completedAt(it), null));
    return yield* tmp.count_q0vep4_k$(tmp$ret$1, $completion);
  }), 1);
}
function SurveyDetailPage$render$slambda$lambda$lambda(it) {
  return it.name_1;
}
function SurveyDetailPage$render$slambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function SurveyDetailPage$render$slambda$lambda$slambda_0($$this$button, $url) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $url;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    setClipboardText(tmp, tmp$ret$0);
    toast($$this$button.get_context_h02k06_k$(), 'Copied to clipboard');
    return Unit_instance;
  }), 0);
}
function SurveyDetailPage$render$slambda_0($$this$button, this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1.get_employer_c2djlo_k$();
    // Inline function 'com.lightningkite.services.database.sort' call
    // Inline function 'kotlin.apply' call
    var this_1 = new (SortBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
    var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$5);
    this_1.ascending_ijynum_k$(get_name(it));
    var tmp$ret$1 = this_1.build_1k0s4u_k$();
    var employers = yield* tmp.query_o986pg_k$(new (Query())(VOID, tmp$ret$1, VOID, 2147483647), $completion);
    var employer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(first(employers));
    var tmp_1 = $$this$button.get_context_h02k06_k$();
    dialog(tmp_1, VOID, ($this$dialog, close) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      var $this$col = element;
      h2($this$col, 'Employee link');
      subtext($this$col, 'Anyone with this link can answer for the employer it names.');
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      var label = 'Employer';
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$col.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      $this$col.willAddChild_hz2iwc_k$(element_0);
      element_0.set_content_lzqutq_k$(label);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.select' call
      var this_1 = themed(element_0, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (Select())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      this_1.willAddChild_hz2iwc_k$(element_1);
      var tmp = _Constant___init__impl__v45mub(employers);
      element_1.bind_64a41i_k$(employer, new (Constant())(tmp), SurveyDetailPage$render$slambda$lambda$lambda);
      element_1.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_1);
      element_0.onStartup_vrxh3i_k$();
      $this$col.addChild_2qpft2_k$(element_0);
      var url = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
        var path = ensureNotNull(get_pageNavigator($this$col.get_context_h02k06_k$()).get_routes_j3zccz_k$().render_y0xm4o_k$(new (AnonymousSurveyPage())(this$0.id_1, $this$remember.invoke_r7m7el_k$(employer)._id_1))).urlLikePath_1.render_fgfjvu_k$();
        return '' + webOrigin() + '/' + path;
      });
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (TextView())($this$col.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      $this$col.willAddChild_hz2iwc_k$(element_2);
      var tmp_0 = KMutableProperty0();
      var tmp_1 = TextView$_get_content_$ref_4pzcwl(element_2);
      var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(element_2));
      element_2.invoke_bnq13k_k$(tmp_2, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(url));
      element_2.onStartup_vrxh3i_k$();
      $this$col.addChild_2qpft2_k$(element_2);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (RowOrCol())($this$col.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      $this$col.willAddChild_hz2iwc_k$(element_3);
      element_3.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_2 = themed(element_3, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (Button())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      this_2.willAddChild_hz2iwc_k$(element_4);
      text(element_4, 'Close');
      onClick(element_4, VOID, VOID, VOID, SurveyDetailPage$render$slambda$lambda$slambda(close));
      element_4.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_4);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_3 = weight(element_3, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = new (Space())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      this_3.willAddChild_hz2iwc_k$(element_5);
      element_5.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_5);
      // Inline function 'com.lightningkite.kiteui.views.important' call
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var this_4 = themed(element_3, ImportantSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_5 = themed(this_4, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_6 = new (Button())(this_5.get_context_h02k06_k$());
      ensureOutermostElement(element_6);
      this_5.willAddChild_hz2iwc_k$(element_6);
      text(element_6, 'Copy link');
      onClick(element_6, VOID, VOID, VOID, SurveyDetailPage$render$slambda$lambda$slambda_0(element_6, url));
      element_6.onStartup_vrxh3i_k$();
      this_5.addChild_2qpft2_k$(element_6);
      element_3.onStartup_vrxh3i_k$();
      $this$col.addChild_2qpft2_k$(element_3);
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 0);
}
function SurveyDetailPage$render$slambda_1($survey, this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var api = (yield* await_0(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $survey;
    var questions = (yield* await_0(this_1, $completion)).questions_1;
    var tmp = api.get_questionResponse_p55ixc_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.filter_1;
    var tmp_0 = (yield* await_1(this_2, $completion)).toCondition_oj74tc_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
    var tmp$ret$5 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$5);
    var tmp$ret$3 = eq(get_survey_0(it), new (ID_1())(this$0.id_1));
    var responses = yield* tmp.query_o986pg_k$(new (Query())(and(tmp_0, tmp$ret$3), VOID, VOID, 2147483647), $completion);
    // Inline function 'kotlin.collections.associate' call
    var this_3 = yield* api.get_employer_c2djlo_k$().query_o986pg_k$(new (Query())(VOID, VOID, VOID, 2147483647), $completion);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_3, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
    var _iterator__ex2g4s = this_3.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(new (ID())(element._id_1), element.name_1);
      destination.put_4fpzoq_k$(pair.first_1, pair.second_1);
    }
    var employerNames = destination;
    var tmp_2 = listOf(['Taker', 'Taking', 'Started', 'Employer', 'Income', 'Leadership', 'Family size', 'City']);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(questions, 10));
    var _iterator__ex2g4s_0 = questions.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp0_safe_receiver = item.item_1;
      var tmp_3;
      if (tmp0_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_3 = item.question_1 + ' \u2014 ' + tmp0_safe_receiver;
      }
      var tmp1_elvis_lhs = tmp_3;
      var tmp$ret$14 = tmp1_elvis_lhs == null ? item.question_1 : tmp1_elvis_lhs;
      destination_0.add_utx5q5_k$(tmp$ret$14);
    }
    var header = plus(tmp_2, destination_0);
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
    var _iterator__ex2g4s_1 = responses.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
      var key = to(element_0.takerId_1, element_0.takerIteration_1);
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_1.get_wei43m_k$(key);
      var tmp_4;
      if (value == null) {
        var answer = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        destination_1.put_4fpzoq_k$(key, answer);
        tmp_4 = answer;
      } else {
        tmp_4 = value;
      }
      var list = tmp_4;
      list.add_utx5q5_k$(element_0);
    }
    // Inline function 'kotlin.collections.map' call
    var this_4 = destination_1.get_values_ksazhn_k$();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_4, 10));
    var _iterator__ex2g4s_2 = this_4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var item_0 = _iterator__ex2g4s_2.next_20eer_k$();
      var first_0 = first(item_0);
      var demographic = first_0.demographic_1;
      var tmp_5 = demographic.takerEmployer_1;
      var employers = plus(listOfNotNull_0(tmp_5 == null ? null : new (ID())(tmp_5)), demographic.supportingEmployers_1);
      // Inline function 'kotlin.collections.associateBy' call
      var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(item_0, 10)), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_3 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_0);
      var _iterator__ex2g4s_3 = item_0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
        var element_1 = _iterator__ex2g4s_3.next_20eer_k$();
        var tmp$ret$27 = new (ID_2())(element_1.question_1);
        destination_3.put_4fpzoq_k$(tmp$ret$27, element_1);
      }
      var byQuestion = destination_3;
      var tmp_6 = first_0.takerId_1.toString();
      var tmp_7 = (first_0.takerIteration_1 + 1 | 0).toString();
      // Inline function 'kotlin.collections.minOf' call
      var iterator = item_0.iterator_jk1svi_k$();
      if (!iterator.hasNext_bitz1p_k$())
        throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
      var minValue = iterator.next_20eer_k$().at_1;
      while (iterator.hasNext_bitz1p_k$()) {
        var v = iterator.next_20eer_k$().at_1;
        if (compareTo(minValue, v) > 0) {
          minValue = v;
        }
      }
      var tmp_8 = minValue.toString();
      var tmp_9 = joinToString(employers, '; ', VOID, VOID, VOID, VOID, (it) => {
        var tmp0_elvis_lhs = employerNames.get_wei43m_k$(it);
        return tmp0_elvis_lhs == null ? ID__toString_impl_y5caka(it.raw_1) : tmp0_elvis_lhs;
      });
      var tmp0_safe_receiver_0 = demographic.income_1;
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.displayName_1;
      var tmp_10 = tmp1_elvis_lhs_0 == null ? '' : tmp1_elvis_lhs_0;
      var tmp2_safe_receiver = demographic.leadershipLevel_1;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : get_displayName_0(tmp2_safe_receiver);
      var tmp_11 = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp4_safe_receiver = demographic.familySize_1;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.toString();
      var tmp_12 = listOf([tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs, demographic.city_1]);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_4 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(questions, 10));
      var _iterator__ex2g4s_4 = questions.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
        var item_1 = _iterator__ex2g4s_4.next_20eer_k$();
        var answer_0 = byQuestion.get_wei43m_k$(new (ID_2())(item_1._id_1));
        var tmp1_elvis_lhs_1 = answer_0 == null ? null : answer_0.answerFreeText_1;
        var tmp_13;
        if (tmp1_elvis_lhs_1 == null) {
          tmp_13 = answer_0 == null ? null : answer_0.answerSingleChoice_1;
        } else {
          tmp_13 = tmp1_elvis_lhs_1;
        }
        var tmp3_elvis_lhs_0 = tmp_13;
        var tmp_14;
        if (tmp3_elvis_lhs_0 == null) {
          var tmp5_safe_receiver = answer_0 == null ? null : answer_0.answerMultipleChoice_1;
          tmp_14 = tmp5_safe_receiver == null ? null : joinToString(tmp5_safe_receiver, '; ');
        } else {
          tmp_14 = tmp3_elvis_lhs_0;
        }
        var tmp6_elvis_lhs = tmp_14;
        var tmp_15;
        if (tmp6_elvis_lhs == null) {
          var tmp8_safe_receiver = answer_0 == null ? null : answer_0.answerScale_1;
          tmp_15 = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.toString();
        } else {
          tmp_15 = tmp6_elvis_lhs;
        }
        var tmp9_elvis_lhs = tmp_15;
        var tmp_16;
        if (tmp9_elvis_lhs == null) {
          var tmp11_safe_receiver = answer_0 == null ? null : answer_0.answerFreeNumber_1;
          tmp_16 = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.toString();
        } else {
          tmp_16 = tmp9_elvis_lhs;
        }
        var tmp12_elvis_lhs = tmp_16;
        var tmp$ret$33 = tmp12_elvis_lhs == null ? '' : tmp12_elvis_lhs;
        destination_4.add_utx5q5_k$(tmp$ret$33);
      }
      var tmp$ret$24 = plus(tmp_12, destination_4);
      destination_2.add_utx5q5_k$(tmp$ret$24);
    }
    var rows = destination_2;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_5 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
    appendCsvRows(this_5, plus_0(sequenceOf(header), asSequence(rows)));
    var csv = this_5.toString();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_6 = $survey;
    var tmp0 = (yield* await_0(this_6, $completion)).name_1;
    // Inline function 'kotlin.text.replace' call
    var fileName = Regex().new_kotlin_text_Regex_acuq4a_k$('[^a-zA-Z0-9._-]+').replace_1ix0wf_k$(tmp0, '-');
    yield* download($$this$button.get_context_h02k06_k$(), fileName + '.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function SurveyDetailPage$render$lambda($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function SurveyDetailPage$render$slambda_2($survey, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $survey;
    var original = yield* await_0(this_0, $completion);
    var tmp = get_pageNavigator($$this$button.get_context_h02k06_k$());
    // Inline function 'kotlin.apply' call
    var this_1 = new (SurveyNewPage())();
    this_1.name_1.set_value_v1vabv_k$(original.name_1 + ' (copy)');
    this_1.audience_1.set_value_v1vabv_k$(original.audience_1);
    var tmp0_safe_receiver = original.maximumFrequency_1;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = imul(tmp0_safe_receiver.get_years_j1r3xp_k$(), 12) + tmp0_safe_receiver.get_months_gqmrjw_k$() | 0;
    }
    this_1.repeatMonths_1.set_value_v1vabv_k$(tmp_0);
    // Inline function 'kotlin.collections.map' call
    var this_2 = original.questions_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s = this_2.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$7 = Companion_instance_0.from_9ti2dg_k$(item);
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    this_1.questions_1.set_value_v1vabv_k$(destination);
    tmp.navigate_sm5lxf_k$(this_1);
    return Unit_instance;
  }), 0);
}
function SurveyDetailPage$render$lambda_0($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function SurveyDetailPage$render$slambda_3(this$0, $$this$button, $survey) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $survey;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    availabilityDialog(this$0, tmp, tmp$ret$0);
    return Unit_instance;
  }), 0);
}
function SurveyDetailPage$render$slambda_4(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.filter_1.set_revjhg_k$(new (SurveyFilters())(), $completion);
    return Unit_instance;
  }), 0);
}
function SurveyDetailPage$render$lambda$lambda(it) {
  return it.employers_1;
}
function SurveyDetailPage$render$lambda$lambda_0(old, it) {
  return old.copy$default_f6m8xw_k$(it);
}
function SurveyDetailPage$render$lambda$lambda_1($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().query_so6xq1_k$(new (Query())(VOID, VOID, VOID, 2147483647)));
}
function SurveyDetailPage$render$lambda$lambda_2(it) {
  return it.name_1;
}
function SurveyDetailPage$render$lambda$lambda_3(it) {
  return it.grants_1;
}
function SurveyDetailPage$render$lambda$lambda_4(old, it) {
  return old.copy$default_f6m8xw_k$(VOID, it);
}
function SurveyDetailPage$render$lambda$lambda_5($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_grants_dxrzz4_k$().query_so6xq1_k$(new (Query())(VOID, VOID, VOID, 2147483647)));
}
function SurveyDetailPage$render$lambda$lambda_6(it) {
  return it.name_1;
}
function SurveyDetailPage$render$lambda$lambda_7(it) {
  return it.incomes_1;
}
function SurveyDetailPage$render$lambda$lambda_8(old, it) {
  return old.copy$default_f6m8xw_k$(VOID, VOID, it);
}
function SurveyDetailPage$render$lambda$lambda_9(it) {
  return it;
}
function SurveyDetailPage$render$lambda$lambda_10(it) {
  return it.displayName_1;
}
function SurveyDetailPage$render$lambda$lambda_11(it) {
  return it.leadershipLevels_1;
}
function SurveyDetailPage$render$lambda$lambda_12(old, it) {
  return old.copy$default_f6m8xw_k$(VOID, VOID, VOID, it);
}
function SurveyDetailPage$render$lambda$lambda_13(it) {
  return it;
}
function SurveyDetailPage$render$lambda$lambda_14(it) {
  return get_displayName_0(it);
}
function SurveyDetailPage$render$lambda$lambda_15(it) {
  return it.cities_1;
}
function SurveyDetailPage$render$lambda$lambda_16(old, it) {
  return old.copy$default_f6m8xw_k$(VOID, VOID, VOID, VOID, it);
}
function SurveyDetailPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1.get_questionResponse_p55ixc_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = eq(get_survey_0(it), new (ID_1())(this$0.id_1));
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
    var tmp$ret$7 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    var tmp$ret$6 = new (DataClassPathSelf())(tmp$ret$7);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = (yield* tmp.groupCount_z3zpjq_k$(new (GroupCountQuery())(tmp_1, get_city(get_demographic(tmp$ret$6))), $completion)).get_keys_wop4xp_k$();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination.add_utx5q5_k$(element);
      }
    }
    return sorted(destination);
  }), 1);
}
function SurveyDetailPage$render$lambda$lambda_17(it) {
  return it;
}
function SurveyDetailPage$render$lambda$lambda_18(it) {
  return it;
}
function SurveyDetailPage$render$lambda_1(it) {
  return it.displayName_1;
}
function SurveyDetailPage$render$lambda_2(it) {
  return new (ID_2())(it._id_1);
}
function SurveyDetailPage$render$lambda$slambda_0(this$0, $question) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $question;
    var tmp = yield* await_0(this_0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.filter_1;
    var tmp_0 = (yield* await_1(this_1, $completion)).toCondition_oj74tc_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.groupBy_1;
    var tmp$ret$2 = yield* await_1(this_2, $completion);
    return yield* /*#__NOINLINE__*/results(this$0, tmp, tmp_0, tmp$ret$2, $completion);
  }), 1);
}
function SurveyDetailPage$render$lambda$lambda$lambda$lambda($this$table, it) {
  return $this$table;
}
function SurveyDetailPage$render$lambda$lambda$lambda$lambda_0($name) {
  return ($this$text) => $name;
}
function SurveyDetailPage$render$lambda$lambda$lambda$lambda_1($index) {
  return ($this$text, it) => it.get_c1px32_k$($index);
}
function SurveyDetailPage$render$lambda$lambda$lambda($next) {
  return ($this$swap) => {
    var r = $next;
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())($this$swap.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$swap.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    var tmp = _Constant___init__impl__v45mub(r.rows_1);
    var tmp_0 = SurveyDetailPage$render$lambda$lambda$lambda$lambda;
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = r.columns_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var tmp_1 = Companion_instance_1;
      var tmp_2 = SurveyDetailPage$render$lambda$lambda$lambda$lambda_0(item);
      var tmp$ret$7 = tmp_1.text$default_gwb2zv_k$(tmp_2, VOID, SurveyDetailPage$render$lambda$lambda$lambda$lambda_1(index_0));
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$8 = copyToArray(destination);
    table(element, new (Constant())(tmp), tmp_0, tmp$ret$8.slice());
    var _iterator__ex2g4s_0 = r.texts_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var text_0 = _iterator__ex2g4s_0.next_20eer_k$();
      text(element, text_0);
    }
    element.onStartup_vrxh3i_k$();
    $this$swap.addChild_2qpft2_k$(element);
    return Unit_instance;
  };
}
function SurveyDetailPage$render$lambda_3($this$shownWhen) {
  return get_current(Companion_instance_2).equals(Platform_Web_getInstance());
}
function SurveyDetailPage$results$slambda$ordered$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0 = get_entries();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      if (item.name_1 === a) {
        tmp$ret$2 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$2 = -1;
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = tmp$ret$2;
  var tmp;
  if (this_0 >= 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_0 = tmp0_elvis_lhs == null ? 2147483647 : tmp0_elvis_lhs;
  var tmp0_0 = get_entries();
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index_0 = 0;
    var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
      if (item_0.name_1 === b) {
        tmp$ret$7 = index_0;
        break $l$block_0;
      }
      index_0 = index_0 + 1 | 0;
    }
    tmp$ret$7 = -1;
  }
  // Inline function 'kotlin.takeIf' call
  var this_1 = tmp$ret$7;
  var tmp_1;
  if (this_1 >= 0) {
    tmp_1 = this_1;
  } else {
    tmp_1 = null;
  }
  var tmp0_elvis_lhs_0 = tmp_1;
  var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? 2147483647 : tmp0_elvis_lhs_0;
  return compareValues(tmp_0, tmp$ret$6);
}
function SurveyDetailPage$results$slambda$ordered$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0 = get_entries_0();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      if (item.name_1 === a) {
        tmp$ret$2 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$2 = -1;
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = tmp$ret$2;
  var tmp;
  if (this_0 >= 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_0 = tmp0_elvis_lhs == null ? 2147483647 : tmp0_elvis_lhs;
  var tmp0_0 = get_entries_0();
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index_0 = 0;
    var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
      if (item_0.name_1 === b) {
        tmp$ret$7 = index_0;
        break $l$block_0;
      }
      index_0 = index_0 + 1 | 0;
    }
    tmp$ret$7 = -1;
  }
  // Inline function 'kotlin.takeIf' call
  var this_1 = tmp$ret$7;
  var tmp_1;
  if (this_1 >= 0) {
    tmp_1 = this_1;
  } else {
    tmp_1 = null;
  }
  var tmp0_elvis_lhs_0 = tmp_1;
  var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? 2147483647 : tmp0_elvis_lhs_0;
  return compareValues(tmp_0, tmp$ret$6);
}
function SurveyDetailPage$results$slambda$ordered$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_elvis_lhs = toIntOrNull(a);
  var tmp = tmp0_elvis_lhs == null ? 2147483647 : tmp0_elvis_lhs;
  var tmp0_elvis_lhs_0 = toIntOrNull(b);
  var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? 2147483647 : tmp0_elvis_lhs_0;
  return compareValues(tmp, tmp$ret$2);
}
function *invoke$counts(groupPath, api, condition, $completion) {
  return groupPath == null ? mapOf(to('All', yield* api.count_q0vep4_k$(condition, $completion))) : (yield* api.groupCount_z3zpjq_k$(new (GroupCountQuery())(condition, groupPath), $completion));
}
function *invoke$averages(groupPath, api, base, property, $completion) {
  return groupPath == null ? mapOf(to('All', yield* api.aggregate_x3h2lp_k$(new (AggregateQuery())(Aggregate_Average_getInstance(), base, property), $completion))) : (yield* api.groupAggregate_efln9_k$(new (GroupAggregateQuery())(Aggregate_Average_getInstance(), base, groupPath, property), $completion));
}
function invoke$label($grouping, employerNames, key) {
  var tmp;
  switch ($grouping.ordinal_1) {
    case 0:
      tmp = key;
      break;
    case 1:
      // Inline function 'kotlin.collections.find' call

      var tmp0 = get_entries();
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (element.name_1 === key) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }

      var tmp1_safe_receiver = tmp$ret$1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.displayName_1;
      tmp = tmp2_elvis_lhs == null ? 'Not given' : tmp2_elvis_lhs;
      break;
    case 2:
      // Inline function 'kotlin.collections.find' call

      var tmp0_0 = get_entries_0();
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          if (element_0.name_1 === key) {
            tmp$ret$4 = element_0;
            break $l$block_0;
          }
        }
        tmp$ret$4 = null;
      }

      var tmp3_safe_receiver = tmp$ret$4;
      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : get_displayName_0(tmp3_safe_receiver);
      tmp = tmp4_elvis_lhs == null ? 'Not given' : tmp4_elvis_lhs;
      break;
    case 3:
      var tmp5_safe_receiver = toIntOrNull(key);
      var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.toString();
      tmp = tmp6_elvis_lhs == null ? 'Not given' : tmp6_elvis_lhs;
      break;
    case 4:
      // Inline function 'kotlin.text.ifBlank' call

      var tmp_0;
      if (isBlank(key)) {
        tmp_0 = 'Unknown';
      } else {
        tmp_0 = key;
      }

      tmp = tmp_0;
      break;
    case 5:
      var tmp7_elvis_lhs = employerNames.get_wei43m_k$(key);
      tmp = tmp7_elvis_lhs == null ? 'None' : tmp7_elvis_lhs;
      break;
    case 6:
      tmp = 'Taking ' + (toInt(key) + 1 | 0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function invoke$ordered($grouping, employerNames, keys) {
  var tmp;
  switch ($grouping.ordinal_1) {
    case 1:
      // Inline function 'kotlin.collections.sortedBy' call

      // Inline function 'kotlin.comparisons.compareBy' call

      var tmp_0 = SurveyDetailPage$results$slambda$ordered$lambda;
      var tmp$ret$1 = new (sam$kotlin_Comparator$0())(tmp_0);
      tmp = sortedWith(keys, tmp$ret$1);
      break;
    case 2:
      // Inline function 'kotlin.collections.sortedBy' call

      // Inline function 'kotlin.comparisons.compareBy' call

      var tmp_1 = SurveyDetailPage$results$slambda$ordered$lambda_0;
      var tmp$ret$3 = new (sam$kotlin_Comparator$0())(tmp_1);
      tmp = sortedWith(keys, tmp$ret$3);
      break;
    case 3:
    case 6:
      // Inline function 'kotlin.collections.sortedBy' call

      // Inline function 'kotlin.comparisons.compareBy' call

      var tmp_2 = SurveyDetailPage$results$slambda$ordered$lambda_1;
      var tmp$ret$5 = new (sam$kotlin_Comparator$0())(tmp_2);
      tmp = sortedWith(keys, tmp$ret$5);
      break;
    default:
      // Inline function 'kotlin.collections.sortedBy' call

      // Inline function 'kotlin.comparisons.compareBy' call

      var tmp_3 = (a, b) => {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp = invoke$label($grouping, employerNames, a);
        var tmp$ret$10 = invoke$label($grouping, employerNames, b);
        return compareValues(tmp, tmp$ret$10);
      };
      var tmp$ret$7 = new (sam$kotlin_Comparator$0())(tmp_3);
      tmp = sortedWith(keys, tmp$ret$7);
      break;
  }
  return tmp;
}
function SurveyDetailPage$results$slambda$slambda($base, $groupPath, $api) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.filterValues' call
    var this_0 = yield* /*#__NOINLINE__*/invoke$counts($groupPath, $api, $base, $completion);
    var result = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this_0.get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var entry = _iterator__ex2g4s.next_20eer_k$();
      if (entry.get_value_j01efc_k$() > 0) {
        result.put_4fpzoq_k$(entry.get_key_18j28a_k$(), entry.get_value_j01efc_k$());
      }
    }
    return result;
  }), 1);
}
function SurveyDetailPage$results$slambda$slambda_0($base, $chose, $groupPath, $api) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    return yield* /*#__NOINLINE__*/invoke$counts($groupPath, $api, and($base, $chose), $completion);
  }), 1);
}
function SurveyDetailPage$results$slambda($filter, $question, $grouping) {
  return constructCallableReference(($this$coroutineScope, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var api = (yield* await_0(this_0, $completion)).api_1.get_questionResponse_p55ixc_k$();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
    var responses = new (DataClassPathSelf())(tmp$ret$2);
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
    var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$5);
    var tmp$ret$3 = eq(get_question(it), new (ID_2())($question._id_1));
    var base = and($filter, tmp$ret$3);
    var tmp_1;
    switch ($grouping.ordinal_1) {
      case 0:
        tmp_1 = null;
        break;
      case 1:
        tmp_1 = get_income(get_demographic(responses));
        break;
      case 2:
        tmp_1 = get_leadershipLevel(get_demographic(responses));
        break;
      case 3:
        tmp_1 = get_familySize(get_demographic(responses));
        break;
      case 4:
        tmp_1 = get_city(get_demographic(responses));
        break;
      case 5:
        tmp_1 = get_takerEmployer(get_demographic(responses));
        break;
      case 6:
        tmp_1 = get_takerIteration(responses);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var groupPath = tmp_1;
    var tmp_2;
    if (!$grouping.equals(SurveyGrouping_Employer_getInstance())) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_2 = emptyMap();
    } else {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = get_currentSessionNotNull();
      // Inline function 'kotlin.collections.associate' call
      var this_2 = yield* (yield* await_0(this_1, $completion)).api_1.get_employer_c2djlo_k$().query_o986pg_k$(new (Query())(VOID, VOID, VOID, 2147483647), $completion);
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
      var _iterator__ex2g4s = this_2.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        // Inline function 'kotlin.collections.plusAssign' call
        var pair = to(ID__toString_impl_y5caka(element._id_1), element.name_1);
        destination.put_4fpzoq_k$(pair.first_1, pair.second_1);
      }
      tmp_2 = destination;
    }
    var employerNames = tmp_2;
    var type = $question.type_1;
    var tmp_3;
    if (type instanceof SingleChoice()) {
      // Inline function 'kotlin.collections.map' call
      var this_3 = type.options_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_3, 10));
      var _iterator__ex2g4s_0 = this_3.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var item = _iterator__ex2g4s_0.next_20eer_k$();
        // Inline function 'com.lightningkite.services.database.condition' call
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_4 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
        var tmp$ret$19 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
        // Inline function 'kotlin.let' call
        var it_0 = new (DataClassPathSelf())(tmp$ret$19);
        var tmp$ret$17 = eq(get_answerSingleChoice(it_0), item);
        var tmp$ret$16 = to(item, tmp$ret$17);
        destination_0.add_utx5q5_k$(tmp$ret$16);
      }
      tmp_3 = destination_0;
    } else {
      if (type instanceof MultipleChoice()) {
        // Inline function 'kotlin.collections.map' call
        var this_4 = type.options_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_4, 10));
        var _iterator__ex2g4s_1 = this_4.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_5 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
          var tmp$ret$27 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_1 = new (DataClassPathSelf())(tmp$ret$27);
          // Inline function 'com.lightningkite.services.database.any' call
          var this_5 = get_notNull(get_answerMultipleChoice(it_1));
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_6 = serializerOrContextual(createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
          var tmp$ret$32 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_2 = new (DataClassPathSelf())(tmp$ret$32);
          var tmp$ret$33 = eq(it_2, item_0);
          var tmp$ret$25 = this_5.mapCondition_3hl8s3_k$(SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(tmp$ret$33));
          var tmp$ret$24 = to(item_0, tmp$ret$25);
          destination_1.add_utx5q5_k$(tmp$ret$24);
        }
        tmp_3 = destination_1;
      } else {
        if (type instanceof Scale()) {
          // Inline function 'kotlin.collections.map' call
          var this_6 = numberRangeToNumber(type.lowerInt_1, type.upperInt_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_2 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_6, 10));
          var inductionVariable = this_6.first_1;
          var last = this_6.last_1;
          if (inductionVariable <= last)
            do {
              var item_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var value = item_1;
              var name = value === type.lowerInt_1 ? '' + value + ' (' + type.lowerName_1 + ')' : value === type.upperInt_1 ? '' + value + ' (' + type.upperName_1 + ')' : value.toString();
              // Inline function 'com.lightningkite.services.database.condition' call
              // Inline function 'com.lightningkite.services.database.path' call
              // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
              var tmp_7 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
              var tmp$ret$40 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
              // Inline function 'kotlin.let' call
              var it_3 = new (DataClassPathSelf())(tmp$ret$40);
              var tmp$ret$38 = eq(get_answerScale(it_3), value);
              var tmp$ret$37 = to(name, tmp$ret$38);
              destination_2.add_utx5q5_k$(tmp$ret$37);
            }
             while (!(item_1 === last));
          tmp_3 = destination_2;
        } else {
          var tmp_8;
          if (equals(type, FreeText_getInstance())) {
            tmp_8 = true;
          } else {
            tmp_8 = type instanceof FreeNumber();
          }
          if (tmp_8) {
            // Inline function 'kotlin.collections.listOf' call
            tmp_3 = emptyList();
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var choices = tmp_3;
    var tmp1_subject = $question.type_1;
    var tmp_9;
    if (tmp1_subject instanceof Scale()) {
      tmp_9 = get_answerScale(responses);
    } else {
      if (tmp1_subject instanceof FreeNumber()) {
        tmp_9 = get_answerFreeNumber(responses);
      } else {
        tmp_9 = null;
      }
    }
    var averaged = tmp_9;
    var totalsAsync = async($this$coroutineScope, VOID, VOID, SurveyDetailPage$results$slambda$slambda(base, groupPath, api));
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(choices, 10));
    var _iterator__ex2g4s_2 = choices.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var item_2 = _iterator__ex2g4s_2.next_20eer_k$();
      var chose = item_2.component2_7eebsb_k$();
      var tmp$ret$46 = async($this$coroutineScope, VOID, VOID, SurveyDetailPage$results$slambda$slambda_0(base, chose, groupPath, api));
      destination_3.add_utx5q5_k$(tmp$ret$46);
    }
    var choiceCounts = yield* awaitAll(destination_3, $completion);
    var tmp_10;
    if (averaged == null) {
      tmp_10 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_10 = yield* /*#__NOINLINE__*/invoke$averages(groupPath, api, base, averaged, $completion);
    }
    var averages = tmp_10;
    var tmp_11;
    if (!equals($question.type_1, FreeText_getInstance())) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_11 = emptyList();
    } else {
      // Inline function 'com.lightningkite.services.database.sort' call
      // Inline function 'kotlin.apply' call
      var this_7 = new (SortBuilder())();
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_12 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
      var tmp$ret$54 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
      var it_4 = new (DataClassPathSelf())(tmp$ret$54);
      this_7.descending_tl4o2_k$(get_at(it_4));
      var tmp$ret$50 = this_7.build_1k0s4u_k$();
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0 = yield* api.query_o986pg_k$(new (Query())(base, tmp$ret$50, VOID, 50), $completion);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_4 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_3 = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_3.next_20eer_k$();
        var tmp0_safe_receiver = element_0.answerFreeText_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_4.add_utx5q5_k$(tmp0_safe_receiver);
        }
      }
      tmp_11 = destination_4;
    }
    var texts = tmp_11;
    var totals = yield* totalsAsync.await_4rdzbx_k$($completion);
    var tmp_13 = listOf([$grouping.equals(SurveyGrouping_None_getInstance()) ? '' : $grouping.displayName_1, 'Responses']);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(choices, 10));
    var _iterator__ex2g4s_4 = choices.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
      var item_3 = _iterator__ex2g4s_4.next_20eer_k$();
      var tmp$ret$65 = item_3.first_1;
      destination_5.add_utx5q5_k$(tmp$ret$65);
    }
    var tmp_14 = plus(tmp_13, destination_5);
    // Inline function 'kotlin.takeIf' call
    var tmp_15;
    if (!(averages == null)) {
      tmp_15 = 'Average';
    } else {
      tmp_15 = null;
    }
    var tmp$ret$66 = tmp_15;
    var tmp_16 = plus(tmp_14, listOfNotNull_0(tmp$ret$66));
    // Inline function 'kotlin.collections.map' call
    var this_8 = invoke$ordered($grouping, employerNames, totals.get_keys_wop4xp_k$());
    // Inline function 'kotlin.collections.mapTo' call
    var destination_6 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_8, 10));
    var _iterator__ex2g4s_5 = this_8.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_5.hasNext_bitz1p_k$()) {
      var item_4 = _iterator__ex2g4s_5.next_20eer_k$();
      var total = getValue(totals, item_4);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_7 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(choiceCounts, 10));
      var _iterator__ex2g4s_6 = choiceCounts.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_6.hasNext_bitz1p_k$()) {
        var item_5 = _iterator__ex2g4s_6.next_20eer_k$();
        var tmp0_elvis_lhs = item_5.get_wei43m_k$(item_4);
        var chosen = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        var tmp$ret$73 = '' + roundToInt(chosen * 100.0 / total) + '% (' + chosen + ')';
        destination_7.add_utx5q5_k$(tmp$ret$73);
      }
      var shares = destination_7;
      var tmp_17;
      if (averages == null) {
        tmp_17 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_safe_receiver_0 = averages.get_wei43m_k$(item_4);
        var tmp_18;
        if (tmp0_safe_receiver_0 == null) {
          tmp_18 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_18 = (roundToInt(tmp0_safe_receiver_0 * 10) / 10.0).toString();
        }
        var tmp1_elvis_lhs = tmp_18;
        tmp_17 = listOf_0(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      }
      var tmp1_elvis_lhs_0 = tmp_17;
      var tmp_19;
      if (tmp1_elvis_lhs_0 == null) {
        // Inline function 'kotlin.collections.listOf' call
        tmp_19 = emptyList();
      } else {
        tmp_19 = tmp1_elvis_lhs_0;
      }
      var average = tmp_19;
      var tmp$ret$70 = plus(plus(listOf([invoke$label($grouping, employerNames, item_4), total.toString()]), shares), average);
      destination_6.add_utx5q5_k$(tmp$ret$70);
    }
    return new (Results())(tmp_16, destination_6, texts);
  }), 1);
}
function SurveyDetailPage$availabilityDialog$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function SurveyDetailPage$availabilityDialog$lambda$slambda_0($start, this$0, $endInclusive, $close) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $start;
    var tmp0_elvis_lhs = yield* await_1(this_0, $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Pick an opening date.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var opens = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_currentSessionNotNull();
    var tmp_0 = (yield* await_0(this_1, $completion)).get_surveys_tdixlc_k$().get_6ueaa7_k$(new (ID_1())(this$0.id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_2 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(Survey()), arrayOf([]), false));
    var tmp$ret$6 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$6);
    var tmp_2 = get_available(it);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $endInclusive;
    var tmp$ret$8 = yield* await_1(this_3, $completion);
    this_2.assign_vtsfu6_k$(tmp_2, new (LocalDateRange())(opens, tmp$ret$8));
    var tmp$ret$2 = this_2.build_1k0s4u_k$();
    yield* tmp_0.modify_ff53f_k$(tmp$ret$2, $completion);
    $close();
    return Unit_instance;
  }), 1);
}
var SurveyDetailPageClass;
function SurveyDetailPage() {
  if (SurveyDetailPageClass === VOID) {
    class $ {
      constructor(id) {
        this.id_1 = id;
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (SurveyFilters())());
        this.groupBy_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(SurveyGrouping_None_getInstance());
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_surveys_tdixlc_k$().get_6ueaa7_k$(new (ID_1())(this.id_1)));
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
          return tmp1_elvis_lhs == null ? 'Survey' : tmp1_elvis_lhs;
        });
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_1().fromParentNonCascading_1);
        var survey = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_surveys_tdixlc_k$().get_6ueaa7_k$(new (ID_1())(this.id_1)));
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Survey ' + ID__toString_impl_y5caka_0(this.id_1) + ' not found');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var visibleQuestions = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var admin = $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.invoke_r7m7el_k$(survey).questions_1;
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (admin || !$this$remember.invoke_r7m7el_k$(survey).audience_1.equals(Audience_Families_getInstance()) || element.employerMaySeeResponse_1) {
              destination.add_utx5q5_k$(element);
            }
          }
          return destination;
        });
        var completed = rememberSuspending(VOID, VOID, VOID, SurveyDetailPage$render$slambda(this));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(survey).name_1);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        var tmp_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_4 = shownWhen(tmp_2, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(survey).audience_1.equals(Audience_AnonymousEmployee_getInstance()) && !(webOrigin() == null));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_5 = themed(this_4, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Button())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_5.willAddChild_hz2iwc_k$(element_2);
        text(element_2, 'Employee link');
        onClick(element_2, VOID, VOID, VOID, SurveyDetailPage$render$slambda_0(element_2, this));
        element_2.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_6 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_7 = themed(this_6, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (Button())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_7.willAddChild_hz2iwc_k$(element_3);
        text(element_3, 'Export CSV');
        element_3.set_action_2ds022_k$(Action('Export survey results', VOID, VOID, VOID, VOID, VOID, SurveyDetailPage$render$slambda_1(survey, this, element_3)));
        element_3.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_3);
        var tmp_3 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_8 = shownWhen(tmp_3, VOID, VOID, SurveyDetailPage$render$lambda);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_9 = themed(this_8, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Button())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_9.willAddChild_hz2iwc_k$(element_4);
        text(element_4, 'Copy');
        onClick(element_4, VOID, VOID, VOID, SurveyDetailPage$render$slambda_2(survey, element_4));
        element_4.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_4);
        var tmp_4 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_10 = shownWhen(tmp_4, VOID, VOID, SurveyDetailPage$render$lambda_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_11 = themed(this_10, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Button())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_11.willAddChild_hz2iwc_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (TextView())(element_5.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        element_5.willAddChild_hz2iwc_k$(element_6);
        var tmp_5 = KMutableProperty0();
        var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_6);
        var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_6));
        element_6.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(survey).available_1 == null ? 'Publish' : 'Change dates');
        element_6.onStartup_vrxh3i_k$();
        element_5.addChild_2qpft2_k$(element_6);
        onClick(element_5, VOID, VOID, VOID, SurveyDetailPage$render$slambda_3(this, element_5, survey));
        element_5.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_5);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (TextView())(element_7.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        element_7.willAddChild_hz2iwc_k$(element_8);
        element_8.set_themeChoice_py59um_k$(element_8.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_8 = KMutableProperty0();
        var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_8);
        var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_8));
        element_8.invoke_bnq13k_k$(tmp_10, ($this$invoke) => 'For ' + get_displayName($this$invoke.invoke_r7m7el_k$(survey).audience_1));
        element_8.onStartup_vrxh3i_k$();
        element_7.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (TextView())(element_7.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element_7.willAddChild_hz2iwc_k$(element_9);
        element_9.set_themeChoice_py59um_k$(element_9.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_11 = KMutableProperty0();
        var tmp_12 = TextView$_get_content_$ref_4pzcwl(element_9);
        var tmp_13 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(element_9));
        element_9.invoke_bnq13k_k$(tmp_13, ($this$invoke) => 'Available: ' + get_availabilityText($this$invoke.invoke_r7m7el_k$(survey)));
        element_9.onStartup_vrxh3i_k$();
        element_7.addChild_2qpft2_k$(element_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_12 = shownWhen(element_7, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(survey).maximumFrequency_1 == null));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (TextView())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_12.willAddChild_hz2iwc_k$(element_10);
        element_10.set_themeChoice_py59um_k$(element_10.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_14 = KMutableProperty0();
        var tmp_15 = TextView$_get_content_$ref_4pzcwl(element_10);
        var tmp_16 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb(element_10));
        element_10.invoke_bnq13k_k$(tmp_16, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(survey).maximumFrequency_1;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = imul(tmp0_safe_receiver.get_years_j1r3xp_k$(), 12) + tmp0_safe_receiver.get_months_gqmrjw_k$() | 0;
          }
          return 'Repeats at most every ' + tmp + ' months';
        });
        element_10.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (TextView())(element_7.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        element_7.willAddChild_hz2iwc_k$(element_11);
        element_11.set_themeChoice_py59um_k$(element_11.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_17 = KMutableProperty0();
        var tmp_18 = TextView$_get_content_$ref_4pzcwl(element_11);
        var tmp_19 = getPropertyCallableRef('content', 0, tmp_17, tmp_18, TextView$_set_content_$ref_pketfb(element_11));
        element_11.invoke_bnq13k_k$(tmp_19, ($this$invoke) => 'Completed ' + $this$invoke.invoke_r7m7el_k$(completed) + ' times');
        element_11.onStartup_vrxh3i_k$();
        element_7.addChild_2qpft2_k$(element_11);
        element_7.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        element.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(false);
        var tmp_20 = SurveyDetailPage$render$slambda_4(this);
        filterMenu(element_12, this.filter_1, tmp_20, ($this$filterMenu) => {
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label = 'Employer';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$filterMenu.willAddChild_hz2iwc_k$(element);
          element.set_content_lzqutq_k$(label);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = themed(element, FieldSemantic_getInstance());
          var tmp_0 = SurveyDetailPage$render$lambda$lambda;
          var tmp_1 = this.filter_1.lens_u4wb4z_k$(tmp_0, SurveyDetailPage$render$lambda$lambda_0);
          var tmp_2 = remember(VOID, VOID, VOID, VOID, SurveyDetailPage$render$lambda$lambda_1);
          chipMultiselect(tmp, tmp_1, tmp_2, SurveyDetailPage$render$lambda$lambda_2, 'Showing all', Companion_getInstance_2().filterList_1);
          element.onStartup_vrxh3i_k$();
          $this$filterMenu.addChild_2qpft2_k$(element);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          $this$filterMenu.willAddChild_hz2iwc_k$(element_0);
          element_0.set_content_lzqutq_k$('Grant');
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_3 = themed(element_0, FieldSemantic_getInstance());
          var tmp_4 = SurveyDetailPage$render$lambda$lambda_3;
          var tmp_5 = this.filter_1.lens_u4wb4z_k$(tmp_4, SurveyDetailPage$render$lambda$lambda_4);
          var tmp_6 = remember(VOID, VOID, VOID, VOID, SurveyDetailPage$render$lambda$lambda_5);
          chipMultiselect(tmp_3, tmp_5, tmp_6, SurveyDetailPage$render$lambda$lambda_6, 'Showing all', Companion_getInstance_2().filterList_1);
          element_0.onStartup_vrxh3i_k$();
          $this$filterMenu.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          $this$filterMenu.willAddChild_hz2iwc_k$(element_1);
          element_1.set_content_lzqutq_k$('Income');
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_7 = themed(element_1, FieldSemantic_getInstance());
          var tmp_8 = _Constant___init__impl__v45mub(true);
          var tmp_9 = SurveyDetailPage$render$lambda$lambda_7;
          var tmp_10 = this.filter_1.lens_u4wb4z_k$(tmp_9, SurveyDetailPage$render$lambda$lambda_8);
          var tmp_11 = _Constant___init__impl__v45mub(toList(get_entries()));
          var tmp_12 = SurveyDetailPage$render$lambda$lambda_9;
          chipMultiselectToggleWithId(tmp_7, new (Constant())(tmp_8), tmp_10, new (Constant())(tmp_11), tmp_12, SurveyDetailPage$render$lambda$lambda_10, 'Showing all', Companion_getInstance_2().filterList_1);
          element_1.onStartup_vrxh3i_k$();
          $this$filterMenu.addChild_2qpft2_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label_0 = 'Leadership';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          $this$filterMenu.willAddChild_hz2iwc_k$(element_2);
          element_2.set_content_lzqutq_k$(label_0);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_13 = themed(element_2, FieldSemantic_getInstance());
          var tmp_14 = _Constant___init__impl__v45mub(true);
          var tmp_15 = SurveyDetailPage$render$lambda$lambda_11;
          var tmp_16 = this.filter_1.lens_u4wb4z_k$(tmp_15, SurveyDetailPage$render$lambda$lambda_12);
          var tmp_17 = _Constant___init__impl__v45mub(toList(get_entries_0()));
          var tmp_18 = SurveyDetailPage$render$lambda$lambda_13;
          chipMultiselectToggleWithId(tmp_13, new (Constant())(tmp_14), tmp_16, new (Constant())(tmp_17), tmp_18, SurveyDetailPage$render$lambda$lambda_14, 'Showing all', Companion_getInstance_2().filterList_1);
          element_2.onStartup_vrxh3i_k$();
          $this$filterMenu.addChild_2qpft2_k$(element_2);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          $this$filterMenu.willAddChild_hz2iwc_k$(element_3);
          element_3.set_content_lzqutq_k$('City');
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_19 = themed(element_3, FieldSemantic_getInstance());
          var tmp_20 = _Constant___init__impl__v45mub(true);
          var tmp_21 = SurveyDetailPage$render$lambda$lambda_15;
          var tmp_22 = this.filter_1.lens_u4wb4z_k$(tmp_21, SurveyDetailPage$render$lambda$lambda_16);
          var tmp_23 = rememberSuspending(VOID, VOID, VOID, SurveyDetailPage$render$lambda$slambda(this));
          var tmp_24 = SurveyDetailPage$render$lambda$lambda_17;
          chipMultiselectToggleWithId(tmp_19, new (Constant())(tmp_20), tmp_22, tmp_23, tmp_24, SurveyDetailPage$render$lambda$lambda_18, 'Showing all', Companion_getInstance_2().filterList_1);
          element_3.onStartup_vrxh3i_k$();
          $this$filterMenu.addChild_2qpft2_k$(element_3);
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_13 = weight(element_12, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (Space())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_13.willAddChild_hz2iwc_k$(element_13);
        element_13.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_13);
        var tmp0 = get_centered(element_12);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label = 'Group by';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        tmp0.willAddChild_hz2iwc_k$(element_14);
        element_14.set_content_lzqutq_k$(label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        var this_14 = themed(element_14, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (Select())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_14.willAddChild_hz2iwc_k$(element_15);
        var tmp_21 = _Constant___init__impl__v45mub(get_entries_1());
        element_15.bind_64a41i_k$(this.groupBy_1, new (Constant())(tmp_21), SurveyDetailPage$render$lambda_1);
        element_15.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_15);
        element_14.onStartup_vrxh3i_k$();
        tmp0.addChild_2qpft2_k$(element_14);
        element_12.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_12);
        var tmp_22 = SurveyDetailPage$render$lambda_2;
        colOf(element, visibleQuestions, tmp_22, VOID, VOID, ($this$colOf, question) => {
          // Inline function 'com.lightningkite.kiteui.views.card' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = themed($this$colOf, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_1 = get_bold(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_1.willAddChild_hz2iwc_k$(element_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(question).item_1;
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp = $this$invoke.invoke_r7m7el_k$(question).question_1 + ' \u2014 ' + tmp0_safe_receiver;
            }
            var tmp1_elvis_lhs = tmp;
            return tmp1_elvis_lhs == null ? $this$invoke.invoke_r7m7el_k$(question).question_1 : tmp1_elvis_lhs;
          });
          element_0.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_0);
          var results = rememberSuspending(VOID, VOID, VOID, SurveyDetailPage$render$lambda$slambda_0(this, question));
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (SwapView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_2 = element_1;
          var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var alreadySwapping = {_v: false};
          reactive(this_2, 8, ($this$reactive) => {
            var c = $this$reactive.invoke_r7m7el_k$(results);
            queue.add_utx5q5_k$(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.isEmpty_y1axqb_k$()) {
                break $l$loop;
              }
              var next = queue.removeAt_6niowx_k$(0);
              try {
                var tmp_0 = Companion_getInstance_3().Fade_1;
                this_2.swap_26x94b_k$(tmp_0, SurveyDetailPage$render$lambda$lambda$lambda(next));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString_0(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_15 = shownWhen(element, VOID, VOID, SurveyDetailPage$render$lambda_3);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (Space())(this_15.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_16);
        this_15.willAddChild_hz2iwc_k$(element_16);
        element_16.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_16);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'SurveyDetailPage', VOID, VOID, [Page()], [3, 4]);
    SurveyDetailPageClass = $;
  }
  return SurveyDetailPageClass;
}
function SurveyGrouping_None_getInstance() {
  static_init();
  return SurveyGrouping_None_instance;
}
function SurveyGrouping_Income_getInstance() {
  static_init();
  return SurveyGrouping_Income_instance;
}
function SurveyGrouping_Leadership_getInstance() {
  static_init();
  return SurveyGrouping_Leadership_instance;
}
function SurveyGrouping_FamilySize_getInstance() {
  static_init();
  return SurveyGrouping_FamilySize_instance;
}
function SurveyGrouping_City_getInstance() {
  static_init();
  return SurveyGrouping_City_instance;
}
function SurveyGrouping_Employer_getInstance() {
  static_init();
  return SurveyGrouping_Employer_instance;
}
function SurveyGrouping_Iteration_getInstance() {
  static_init();
  return SurveyGrouping_Iteration_instance;
}
//region block: exports
export {
  SurveyDetailPage as SurveyDetailPage3czjqatyupm6x,
  SurveyFilters as SurveyFilters2cjo777kkjhq1,
  SurveyGrouping as SurveyGrouping2hhrlvdnne3oa,
};
//endregion

//# sourceMappingURL=SurveyDetailPage.mjs.map
